import { useContext } from "react"
import ScheduledTaskReportExportContext from "../ScheduledTaskReportExportContext"

const useScheduledTaskReportExportContext = () => {
  const providedValue = useContext(ScheduledTaskReportExportContext)

  return { ...providedValue }
}

export default useScheduledTaskReportExportContext
